/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-anonymous-default-export */
import React, { useState } from "react";
import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import "./EmployerLandingLeadPage.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleDown,
  faArrowDown,
  faArrowRight,
  faCalendarAlt,
  faFileAlt,
  faFileArchive,
  faQuoteLeft,
  faVideoCamera,
  faUserTie,
  faFileVideo,
  faLayerGroup,
  faDisplay,
} from "@fortawesome/free-solid-svg-icons";

export default ({ props }) => {
  const scrollHandler = (id) => {
    var element = document.getElementById(id);
    window.scrollTo(0, element.offsetTop - 80);
  };
  return (
    <div className="landing-lead-page employer-landing text-dark-5 bg-white">
      <header className="landing-page-header py-4 py-md-5">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-3 col-4">
              <a href="/" className="logo">
                <img src="./assets/images/logo-2.png" alt="logo" />
              </a>
            </div>
            <div className="col-md-9 col-8">
              <ul className="d-flex justify-content-end mb-0 align-items-center">
                <li>
                  <a href="/mentors" className="font-weight-bold">
                    For SMEs
                  </a>
                </li>
                <li className="ml-2 ml-md-4">
                  <a href="/candidates" className="font-weight-bold">
                    For Candidates
                  </a>
                </li>
                {/* <li className="ml-2 ml-md-4">
                  <a
                    href="/sign-in"
                    className="btn btn-green btn-big text-uppercase font-weight-bold"
                  >
                    Sign In
                  </a>
                </li>
             
                <li className="ml-2 ml-md-4">
                  <a
                    href="/sign-up"
                    className="btn btn-green btn-big text-uppercase font-weight-bold"
                  >
                    Sign Up
                  </a>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </header>

      <div className="landing-lead-page-banner text-center">
        <h2 className="font-weight-normal mb-3">Discover the power of</h2>
        <h1 className="text-dark-8">White Glove Recruiting</h1>
        <h2 className="mb-2 font-weight-normal">
          SMEs instead of Recruiters .
        </h2>
        <h2 className="mb-5 font-weight-normal">
          See what <span className="text-green"> SMEs </span> can do for you.
        </h2>
        <a
          href="/sign-up"
          className="btn btn-big btn-green text-uppercase font-weight-bold"
        >
          Join Now
        </a>

        <p className="mt-5 mb-4">See Features</p>
        <button
          className="border-0 bg-transparent"
          onClick={() => scrollHandler("DemoSection")}
        >
          <FontAwesomeIcon icon={faAngleDown} />
        </button>
      </div>

      <div
        className="landing-lead-page-features text-center bg-light-5 py-5 "
        id="DemoSection"
      >
        <div className=" py-md-5">
          <h2 className="mb-4 font-weight-normal text-dark-8">
            Reimagined Process.
          </h2>
          <h3 className="mb-5 font-weight-normal  text-dark-8">
            Hire SME vetted and qualified candidates instantly
          </h3>
          <div className="row">
            <div className="col-md-3">
              <div className="feature-box-2 ">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faLayerGroup} />
                </div>
                <h4 className="mb-4 text-dark-6">⁠AI Platform</h4>
                <p className="font-weight-bold text-dark-5">
                  {" "}
                  Our AI platform simplifies sourcing and screening highly
                  qualified candidates, significantly reducing the time and
                  effort required to find top talent.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="feature-box-2 ">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faUserTie} />
                </div>
                <h4 className="mb-4 text-dark-6"> ⁠Human in the Loop</h4>
                <p className="font-weight-bold text-dark-5">
                  Beyond AI screening, Candidates are thoroughly evaluated and
                  rated by our network of subject matter experts, ensuring only
                  the best candidates are considered.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="feature-box-2 ">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faFileVideo} />
                </div>
                <h4 className="mb-4 text-dark-6">Video Recordings</h4>
                <p className="font-weight-bold text-dark-5">
                  All assessments and evaluations are video recorded and
                  accessible to employers. This transparency provides confidence
                  in the candidate's abilities and the vetting process.
                </p>
              </div>
            </div>
            <div className="col-md-3">
              <div className="feature-box-2 ">
                <div className="icon text-green-2 mb-4">
                  <FontAwesomeIcon icon={faDisplay} />
                </div>
                <h4 className="mb-4 text-dark-6">
                  Simplified Employer Interface
                </h4>
                <p className="font-weight-bold text-dark-5">
                  Employers receive a single URL for each candidate that
                  summarizes their skills, ratings, and evaluation videos. This
                  concise presentation allows for quick and informed hiring
                  decisions.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="landing-lead-page-reviews text-center  my-5 ">
        <div className="container py-md-5">
          <h2 className="mb-5 font-weight-normal text-dark-8">
            Rave Reviews{" "}
            <span className="text-light-5">From Our Early Users. </span>
          </h2>
          <div className="icon text-green-2 mb-5">
            <FontAwesomeIcon icon={faQuoteLeft} />
          </div>
          <div className="">
            <p className="mb-5 text-left">
              Assessment kits literally saved me hundreds of hours not answering
              the same questions in every interview. Who knew such a simple
              thing can be so helpful.
            </p>
            <h4 className="text-green font-weight-normal">— Max</h4>
          </div>
        </div>
      </div>

      <div className="landing-lead-page-highlight my-5">
        <div className="container py-md-5">
          <div className="col-md-10 px-0 mx-auto">
            <h2 className="mb-4 text-black font-weight-bold">
              SMEs are heroes
            </h2>
            <p className="mb-5 pt-3">
              SMEs play a crucial role in identifying, nurturing, and evaluating
              potential candidates, contributing significantly to the overall
              success of the hiring process.
            </p>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">01</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Independent Evaluation
                    </h3>
                    <p>
                      External SMEs, not being directly associated with the
                      hiring organization, offer an impartial and unbiased
                      evaluation of candidates. Their independence allows them
                      to assess candidates solely on merit, skills, and
                      potential, without the influence of internal politics or
                      preconceived notions.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">02</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Industry Insights:
                    </h3>
                    <p>
                      SMEs with diverse industry backgrounds provide valuable
                      insights into current market trends, best practices, and
                      emerging skills. This external perspective aids in
                      identifying candidates who possess a broader skill set and
                      a deep understanding of industry-specific challenges,
                      making them valuable assets to the organization.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">03</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Network Connections:
                    </h3>
                    <p>
                      External SMEs often have extensive professional networks.
                      Leveraging these connections, they can recommend
                      candidates who not only meet the job requirements but also
                      bring a network of valuable contacts, potentially
                      enhancing collaboration and partnerships for the hiring
                      organization.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">04</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Diversity and Inclusion
                    </h3>
                    <p>
                      External SMEs, free from internal biases, are better
                      positioned to advocate for diversity and inclusion in the
                      hiring process. Their external viewpoint encourages
                      organizations to consider a more diverse pool of
                      candidates, leading to a workforce that reflects a broader
                      range of perspectives and experiences.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">05</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Objective Skill Assessment
                    </h3>
                    <p>
                      SMEs, having mentored individuals across various
                      organizations, develop a keen eye for assessing skills
                      objectively. This skill evaluation is based on real-world
                      experiences and industry standards, ensuring that the
                      candidates selected possess the competencies necessary for
                      success in the given role.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="highlight-box mb-4">
              <div className="row align-items-start">
                <div className="col-3">
                  <div className="count font-weight-bold text-green">06</div>
                </div>
                <div className="col-9">
                  <div className="content">
                    <h3 className="text-black mb-3 font-weight-bold">
                      Enhanced Brand Perception
                    </h3>
                    <p>
                      Collaborating with respected external SMEs sends a
                      positive message to potential candidates. It communicates
                      that the organization values external perspectives, seeks
                      the best talent, and is committed to providing a fair and
                      unbiased hiring process. This, in turn, enhances the
                      organization's employer brand and attractiveness to
                      top-tier candidates.{" "}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="landing-lead-page-mentorship text-center  my-5">
        <div className="container py-md-5">
          <div className="col-md-10 mx-auto">
            <h5 className="font-weight-bold text-dark-7 mb-4">Mentorship</h5>
            <h1 className="mb-4 text-black font-weight-bold">
              Got the experience? Become an SME instead.
            </h1>
            <p className="mb-4 text-black">
              Earn serious dough while helping folks find their dream job.
              Interview and SMEs. Choose your own hours.
            </p>
            <a
              href="/mentors"
              className="btn btn-big btn-green font-weight-bold"
            >
              Learn More
            </a>
          </div>
        </div>
      </div>
      <footer className="landing-lead-page-footer py-4">
        <div className="container text-white text-center py-2 font-weight-bold">
          <p className="mb-0">
            © Copyright 2023 • Jigsaw •{" "}
            <a href="/privacy-policy" className="text-white">
              Privacy Policy
            </a>
          </p>
        </div>
      </footer>
    </div>
  );
};
